(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuUpdateFirmwareController', OnuUpdateFirmwareController);

    OnuUpdateFirmwareController.$inject = ['$rootScope', '$scope', '$uibModalInstance', 'OnuService', 'onuItem'];

    function OnuUpdateFirmwareController($rootScope, $scope, $uibModalInstance, OnuService, onuItem) {

        // Variables and Objects
        var vm = this;

        vm.requestRunning = false;
        vm.selectedFile = null;
        vm.selectedOnus = [];
        vm.currentPage = 1;
        vm.totalItems = 0;
        var serverData = {};
        var onuIds = [];
        var item = false;

        // Method handler
        vm.close = close;
        vm.changePage = changePage;

        // Method API
        vm.updateFirmware = updateFirmware;

        initialize();

        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        function updateFirmware() {
            setOnusSelected();
            if (vm.formUpdateOnuFirmware.$valid && vm.selectedOnus.length && !vm.requestRunning) {
                vm.requestRunning = true;
                var data = {
                    file: vm.selectedFile,
                    onuIds: vm.selectedOnus
                };

                if (data.onuIds.length >= 2) {
                    item = true;
                } else {
                    item = false;
                }
                OnuService.updateOnu(data).then(successUpdate).catch(errorUpdate);
            }
        }

        function setOnusSelected() {
            vm.selectedOnus = [];
            vm.modelFirmware.onus.forEach(function (item) {
                if (item.checked) {
                    vm.selectedOnus.push(item.onuId);
                }
            });
        }

        function setPage(page) {
            vm.modelFirmware = angular.copy(serverData[page - 1]);
        }

        function changePage() {
            vm.selectedFile = null;
            vm.selectedOnus = [];
            vm.formUpdateOnuFirmware.$setPristine();
            setPage(vm.currentPage);
        }

        // Requests Callbacks
        function successGetFiles(data) {
            serverData = data;
            vm.totalItems = data.length;
            setPage(1);
        }

        function errorGetFiles(response) {
            OnuService.errorModalConstructor(response, 'getFiles');
            close();
        }

        function successUpdate(response) {
            vm.requestRunning = false;
            var isMultiple = item;

            if (response.status == 207) {
                OnuService.warningModalConstructor(response.data, response, 'delete');
            } else {
                if (vm.totalItems > 1 || vm.modelFirmware.onus.length > 1) {
                    OnuService.successModalConstructorNotClose('update', isMultiple);
                } else {
                    OnuService.successModalConstructor('update', isMultiple);
                }
            }

            $rootScope.$emit('onuUpdateFirmware', response.data);
        }

        function errorUpdate(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, 'update');
        }

        function initialize() {
            vm.modelFirmware = {
                oltId: 0,
                oltName: '',
                onus: [],
                files: []
            };
            onuItem.forEach(function (item) {
                onuIds.push(item.id);
            });

            OnuService.getFiles(onuIds).then(successGetFiles).catch(errorGetFiles);
        }

    }

})();